import React from "react";
import { CasinoIcon, EntriesIcon } from "@picklebet/ui";
import type { CasinoCategory } from "@/features/casino/models/casinoCategory";
import { getCategoryPath } from "@/features/casino/utils/helpers";
import { CategoryIcon } from "@/features/casino/components/CategoryIcon";
import { ReactComponent as ProvidersIcon } from "@/features/casino/components/assets/providers.svg";
import { under } from "../utils/isNavItemActive";
import type { NavItem, NavLocation } from "../types";
import { link } from "./shared";

const casinoPath = ({ pathname }: NavLocation) => {
  const [root, area, rest] = pathname.split("/").filter(Boolean);
  return root === "casino" ? { area, rest } : {};
};

export const casino = (categories: CasinoCategory[]): NavItem => {
  const children: NavItem[] = [
    {
      id: "casino/all",
      text: "All Casino",
      icon: <EntriesIcon />,
      target: link("/casino/lobby/"),
      activeWhen: (context) => {
        const { area, rest } = casinoPath(context);
        if (area === "lobby" || area === "games") return true;
        return Boolean(
          area && !rest && categories.some((category) => category.id === area),
        );
      },
    },
    ...categories.map(
      (category): NavItem => ({
        id: `casino/${category.id}`,
        text: category.name,
        icon: <CategoryIcon iconUrl={category.iconUrl} />,
        target: link(getCategoryPath(category.id)),
        activeWhen: (context) => {
          const { area, rest } = casinoPath(context);
          return area === "categories" && rest === category.id;
        },
      }),
    ),
    {
      id: "casino/providers",
      text: "All Providers",
      icon: <ProvidersIcon />,
      target: link("/casino/providers/"),
      activeWhen: (context) => casinoPath(context).area === "providers",
    },
  ];

  return {
    id: "casino",
    text: "Casino",
    isNew: true,
    icon: <CasinoIcon />,
    target: link("/casino/lobby/"),
    noSnippet: true,
    activeWhen: under("/casino"),
    children: children.map((item) => ({ ...item, noSnippet: true })),
  };
};
